"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var searchApi_1 = __importDefault(require("../mock/searchApi"));
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var SearchApi = {
    getSearchContent: function (token) {
        return rest_1.default.get({
            mockFunc: function () { return searchApi_1.default; },
            url: "".concat(coreServiceUrl, "/search-content"),
            token: token,
        });
    },
};
exports.default = SearchApi;
